<template>
  <div>
    <li v-b-toggle="'collapse-' + index" class="list-group-item">
      <label>{{ bucketData.objectname }}</label>
      <input
        type="checkbox"
        v-model="checkedValue"
        @change="setUserAccessData(bucketData)"
        class="float-right mt-1"
        @click.stop="handleChildClick"
      />
    </li>

    <div style="clear:both;"></div>
    <b-collapse :id="'collapse-' + index" class="mt-0">
      <ul class="list-group bucketChildItem" v-if="bucketData.child.length">
        <tabs
          v-for="(ch, count) in bucketData.child"
          :key="count"
          :tab="ch"
          :userId="userId"
          :tabActive="'is_visible' in ch ? ch.is_visible : ch.IsActive"
          @collectDataHandlerTabs="collectDataHandlerBuckets"
        ></tabs>
      </ul>
    </b-collapse>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Tabs from "./Tabs.vue";
export default {
  name: "Buckets",
  components: {
    Tabs,
  },
  props: {
    index: Number,
    bucket: Object,
    userId: Number,
    is_visible: Boolean,
    collectDataHandlerAccess: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      checkedValue: false,
      bucketData: this.bucket ? this.bucket : {},
    };
  },
  mounted() {
    this.checkedValue = this.is_visible;
  },
  computed: {
    isActive() {
      return this.checkedValue;
    },
  },
  methods: {
    ...mapActions({
      modifyUserAccessData: "modifyUserAccessData",
      getEditedUserAccessDetails: "getEditedUserAccessDetails",
    }),
    handleChildClick(){
      console.log('stopping parent click on checkbox')

    },
    collectDataHandlerBuckets(value) {
      for (let buck of this.bucketData.child) {
        if (value.objectname === buck.objectname) {
          buck.is_visible = value.is_visible;
        }
      }
      this.$emit("collectDataHandlerAccess", this.bucketData);
    },
    async setUserAccessData(bucketobj) {
      // console.log("bucketobj+++", bucketobj);
      const chartaccessdata = {
        child: bucketobj.child,
        objectname: bucketobj.objectname,
        is_visible: this.isActive,
        is_downloadable: this.isActive,
        read_only: this.isActive,
        userId: this.userId,
        object_id: bucketobj.id,
      };
      let chartaccessdataArr = [];
      for (let i = 0; i < chartaccessdata.child.length; i++) {
        chartaccessdataArr.push({
          objectname: bucketobj.child[i].objectname,
          is_visible: this.isActive,
          is_downloadable: this.isActive,
          read_only: this.isActive,
          userId: this.userId,
          object_id: bucketobj.child[i].id,
        });
      }
      this.bucketData = {};
      this.bucketData.child = [];
      // this.$emit("collectDataHandlerAccess", chartaccessdata);
      // this.modifyUserAccessData(chartaccessdata);
      // await this.getEditedUserAccessDetails(this.userId);
      setTimeout(() => {
        this.bucketData = chartaccessdata;
        this.bucketData.child = chartaccessdataArr;
        this.$emit("collectDataHandlerAccess", this.bucketData);
      }, 10);
    },
  },
};
</script>

<style></style>
